
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-news",
      function () {
        return require("private-next-pages/company-news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-news"])
      });
    }
  